import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dialog, Listbox, Menu, Transition } from "@headlessui/react";

// file import 
import Toast from "../assetLibComponents/shared/Toast";
import InboxContainer from "./Inbox"
import TabLiveChat from "./TabLiveChat";
import Looking from "../../assets/zoiLooking.gif"

// firebase
import { ref, onValue } from 'firebase/database';
import { db } from '../../firebase'; // Update the path to your firebaseConfig.js file

// library
import EmojiTextArea from 'react-input-emoji';
import makeAnimated from 'react-select/animated';
import { DebounceInput } from "react-debounce-input";
import Select from 'react-select';

// api action
import { fetchLiveChatAllListing, addLeads, editUserData, fetchLiveConversationListing, assignConversationLead, createTeam, createLabel, assignLabel, fetchSearchList } from "../../redux/actions/liveChatActions";

// css file
import "../chatAiComponents/ChatAii.css"
import "../liveChat/livechat.css"

// icons 
import { BsThreads, BsWechat } from "react-icons/bs";
import {PaperClipIcon,XMarkIcon,MagnifyingGlassIcon} from '@heroicons/react/20/solid';
import { Bars2Icon, CheckIcon, ChevronDownIcon, PlusIcon } from "@heroicons/react/24/outline";
import { TextLeft, Gear, ChatText, ArrowDownUp, Check2, Pencil, X, PersonSquare, SquareFill, Plus, Dash, CircleFill, Send, Fullscreen, Magic, ChevronDoubleUp, ChevronDoubleDown, Inbox, Funnel, FunnelFill } from 'react-bootstrap-icons';


const animatedComponents = makeAnimated();

// conversation tab 
const tabs = [
    { name: "Mine", current: true },
    { name: "Unassigned", current: false },
    { name: "All", current: false },
];

// search popup tab data 
const searchTabs = [
    // { name: "All", current: true },
    { name: "Contacts", current: false },
    // { name: "Conversations", current: false },
    { name: "Messages", current: false },
];

// chat priority data
const priorityData = [
    { id: 3, name: "High", icon:ChevronDoubleUp, color: "#ff5630" },
    { id: 2, name: "Medium", icon:Bars2Icon, color: "#FFAB00" },
    { id: 1, name: "Low", icon:ChevronDoubleDown, color: "#0065ff" },
];

// left menu data
const navigation = [
    { name: 'Conversation', href: '/livechat/conversations/mine', icon: ChatText, current: "conversation" },
    // { name: 'Mentions', href: '/livechat/mentions/mine', icon: BsThreads, current: "mentions" },
    // { name: 'Unattended', href: '/Chat-Ai/text', icon: EnvelopeDash, current: "unattended" },
]


// extreme left menu data
const navigationLeft = [
    { name: 'Conversation', href: '/livechat/conversations', icon: ChatText, current: "conversations" },
    { name: 'Leads', href: '/Lead-Management', icon: PersonSquare, current: "leads" },
    // { name: 'Reports', href: '/livechat/report', icon: Clipboard2Pulse, current: "unattended" },
    // { name: 'Help Center', href: '/livechat/center', icon: QuestionSquare, current: "unattended" },
]


// filter status
const statusFilter = [
    {id:"1", name:"open"},
    {id:"2", name:"resolved"},
    {id:"3", name:"pending"},
    {id:"4", name:"all"}
]

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export default function ChatPage(props) {
    // dispatch and navigate 
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    // authtoken 
    const authToken = props.authToken;
    
    // reference 
    const dropdownRef = useRef();
    // const messageEl = useRef(null);
    const fileInputRef = useRef(null);
    const cancelButtonRef = useRef();
    
    // query and params in url 
    const params = new URLSearchParams(window.location.search);
    const pageName = window.location.pathname.slice(10);
    
    // query in url 
    const newId1 = params.get('inbox');
    const newId2 = params.get('conversation');
    const [inboxParam, setInboxParam] = useState("");
    const [conversationParam, setConversationParam] = useState("");
    const urlFilterV = params.get('filter_v');
    
    // state initialisation 
    const [tabName, setTabName] = useState("Mine");
    const [userData, setUserData] = useState([]);
    const [searchListData, setSearchListData] = useState([]);
    
    // inbox status 
    const [listingStatus, setListingStatus] = useState("All");
    
    // agent status 
    const [agentStatus, setAgentStatus] = useState(1);
    const [agentStatusFlag, setAgentStatusFlag] = useState(1);
    const [assignAgentData, setAssignAgentData] = useState([]);
    
    // scroll on open dropdown
    const [dropControl, setDropControl] = useState("");
    
    // filter and sorting value 
    const [initialFilter, setInitialFilter] = useState("status");
    const [filterNewValue, setFilterNewValue] = useState("");
    const [filterOperator, setFilterOperator] = useState("equal");
    const [filterValue, setFilterValue] = useState({id:"4", name:"all"});
    const [sortingValue, setSortingValue] = useState("null");
    
    // search popup 
    const [searchCount, setSearchCount] = useState(null);
    const [searchTabName, setSearchTabName] = useState("Contacts");
    const [assistAction, setAssistAction] = useState("");
    
    const [searchValue, setSearchValue] = useState("");
    
    // label data
    const [labelData, setLabelData] = useState([]);
    const [labelSearch, setLabelSearch] = useState("");
    const [labelId, setLabelId] = useState(null);
    const [labelName, setLabelName] = useState("");
    const [labelDescription, setLabelDescription] = useState("");
    const [labelColor, setLabelColor] = useState("#59adbc");
    const [globalError, setGlobalError] = useState(false);
    
    // listing data 
    const [selected, setSelected] = useState(null);
    const [listingData, setListingData] = useState(null);
    const [selectedPriority, setSelectedPriority] = useState(null);
    
    // popup open close flag 
    const [open, setOpen] = useState(false);
    const [show, setShow] = useState(false);
    const [submenuOpen, setSubmenuOpen] = useState(true);
    const [detailMinimize, setDetailMinimize] = useState(true);
    const [assistPop, setAssistPop] = useState(false);
    const [openTeam, setOpenTeam] = useState(false);
    const [editDetail, setEditDetail] = useState(false);
    const [filterPopup, setFilterPopup] = useState(false);
    const [showSearchPopup, setShowSearchPopup] = useState(false);
    const [openLeadPopup, setOpenLeadPopup] = useState(false);
    
    // label and team 
    const [teamName, setTeamName] = useState("");
    const [teamDescription, setTeamDescription] = useState("");
    const [teamId, setTeamId] = useState(null);
    const [teamAgent, setTeamAgent] = useState([]);
    const [assignAgentList, setAssignAgentList] = useState([]);    
    // add lead states 
    const [fname, setFname] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [city, setCity] = useState("");
    const [designation, setDesignation] = useState("");
    const [company, setCompany] = useState("");
    const [companyWebsite, setCompanyWebsite] = useState("");
    
    const num_id = useSelector((state) => state.assetLibrary?.userData);
    
    // input tag for chat 
    const [text, setText] = useState('');
    const [editorStatus, setEditorStatus] = useState("reply");
    
    // agent data 
    const agentCaptureData = useSelector(
        (state) => state.assetLibrary.userData
    );
    
    // inbox listing
    const live_chat_listing = useSelector(
        (state) => state.livechat.live_chat_listing?.data
    );
    
    // inbox list count
    const live_chat_count = useSelector(
        (state) => state.livechat.live_chat_listing?.count
    );
    
    // team list 
    const team_list = useSelector(
        (state) => state.livechat.assign_list?.team_list
    );
    
    // agent list
    const assign_list = useSelector(
        (state) => state.livechat.assign_list?.assignee_list
    );
    
    // label list 
    const label_list = useSelector(
        (state) => state.livechat.assign_list?.tag_list
    );
    
    // lead id for lead detail 
    const lead_id_store = useSelector(
        (state) => state.livechat.live_bot_listing?.lead_id
    );
    const user_detail_left = useSelector(
        (state) => state.crmLeads.userActivityDetails?.data?.lead_response
    );
    const user_detail = useSelector(
        (state) => state.crmLeads.userActivityDetails?.data?.response
    );
    
    // token 
    const prospect_token = useSelector(
        (state) => state.livechat.live_bot_listing?.prospect_token
    );
    
    // selected dropdown data 
    const fetch_select_data = useSelector(
        (state) => state.livechat.lead_select_data?.data
    );
    const fetch_tag_data = useSelector(
        (state) => state.livechat.lead_select_data?.tag_data
    );
    
    // first load api data 
    useEffect(() => {
        dispatch(fetchLiveChatAllListing(authToken));
    }, []);
    
    useEffect(() => {
        const assignAgentRef = ref(
            db,
            `/users/${num_id.new_client_id}/LiveList/AssigneeList`
        );
        const onIdStatusChange = onValue(assignAgentRef, (snapshot) => {
            const idStatus = snapshot.val();
            if (idStatus !== null) {
                console.log(idStatus);
                setAssignAgentData(idStatus);
            } else {
                setAssignAgentData(assign_list);
            }
        });

        return () => {
            // Cleanup by detaching the listener when component unmounts
            onIdStatusChange();
        };
        
    }, [assign_list])
    
    
    // label search on combobox 
    useEffect(() => {
        if (label_list?.length > 0) {
            let data_arr = [...label_list]
            let data = data_arr.filter((item) => {
                return item?.tag_name?.includes(labelSearch);
            });
            setLabelData(data);
        }
    }, [labelSearch])
    
    // scroll to down on dropdown open 
    useEffect(() => {
        if (dropdownRef) {
                dropdownRef?.current?.addEventListener('DOMNodeInserted', event => {
                const { currentTarget: target } = event;
                target.scroll({ top: target.scrollHeight});
            });
        }
    }, [dropControl])
    
    // assign and label list formatting on list update 
    useEffect(() => {
        if (assignAgentData?.length > 0) {
            let data = [...assignAgentData];
            data?.map((assign, a_ind) => {
                assign.id = assign.user_id;
                assign.value = assign.first_name + " " + assign.last_name;
                assign.label = assign.first_name + " " + assign.last_name;
                return assign;
            })
            setAssignAgentList(data);
            console.log(assignAgentList);
        } else {
            setAssignAgentList([]);
        }
        
        if (label_list?.length > 0) {
            let dataLabel = [...label_list];
            dataLabel?.map((label, a_ind) => {
                label.id = label.Tag_id;
                label.value = label.Tag_name;
                label.label = label.Tag_name;
                return label;
            })
            setLabelData(dataLabel);
        } else {
            setLabelData();
        }
    }, [assignAgentData, label_list])
    
    // selected data in priority, assign agent
    useEffect(() => {
        if (fetch_select_data !== null) {
            let priority = priorityData?.filter((item) => item?.id == fetch_select_data?.conversation_status);
            let assignee = assignAgentList?.filter((item_) => item_?.user_id == fetch_select_data?.assignee_id)
            setSelectedPriority(priority[0]);
            setSelected(assignee[0])
        }
    }, [fetch_select_data])
    
    // lead detail data on first load 
    useEffect(() => {
        if (user_detail_left?.length > 0) {
            let dataArr = [...user_detail_left]
            if (dataArr?.length > 0) {
                dataArr.map(async (obj, o_ind) => {
                    if (obj?.options?.length > 0 && obj.values !== null) {
                        const objData = await obj.options.find(
                            (option) => option?.id == obj?.values
                        );
                        obj.values = objData;
                    }
                    return obj;
                });
            }
            setUserData(dataArr);
        }
    }, [user_detail_left]);
    
    // inbox listing data
    useEffect(() => {
        setListingData(live_chat_listing);
    }, [live_chat_listing])
    
    // call the inbox api on every url change 
    useEffect(() => {
        fetchQueryParams();
    }, [window.location.search]) 
    
    // scroll down the chat data on new message 
    // useEffect(() => {
    //     if (messageEl) {
    //         messageEl?.current?.addEventListener('DOMNodeInserted', event => {
    //             const { currentTarget: target } = event;
    //             target.scroll({ top: target.scrollHeight });
    //         });
    //     }
    // }, [])
    
    
    useEffect(() => {
      const agentStatusRef = ref(
            db,
            `/users/${num_id.new_client_id}/AgentStatus/${num_id.id}`
        );
        const onIdStatusChange = onValue(agentStatusRef, (snapshot) => {
            const idStatus = snapshot.val();
            if (idStatus !== null) {
                console.log(idStatus);
                setAgentStatus(idStatus?.agent_status)
            }
        });

        return () => {
            // Cleanup by detaching the listener when component unmounts
            onIdStatusChange();
        };
    }, [agentStatusFlag])
    
    // for fetching query data if present and pass to the inbox api for filter and sort 
    const fetchQueryParams = () => {
        const params = new URLSearchParams(window.location.search);
        const filter_i = params.get('filter_i');
        const filter_o = params.get('filter_o');
        const filter_v = params.get('filter_v');
        const sort_value = params.get('sort');
        let tabValue;
        if (window?.location?.pathname?.includes("mine")) {
            tabValue = "assigned"
        } else if (window?.location?.pathname?.includes("unassigned")) {
            tabValue = "unassigned"
        } else {
            tabValue = "all"
        }
        setSortingValue(sort_value);
        setInitialFilter(filter_i || "status");
        setFilterOperator(filter_o || "equal");
        setFilterNewValue(filter_v || "all");
        if (filter_i === "status") {
            setListingStatus(filter_v);
        } else {
            setListingStatus(filter_v || "All")
        }
        dispatch(fetchLiveConversationListing(authToken, tabValue, filter_i, filter_o, filter_v, sort_value, "none"))
    };
    
    // adding emoji in chat input 
    const handleEmojiClick = (emoji) => {
        setText((prevText) => prevText + emoji);
    };
    
    // removing assign label 
    const handleRemoveAssign = (data) => {
        let payload = {
            inbox_id: newId1,
            conversation_id: newId2,
            tag_id: data?.tag_id,
            status: "removed"
        }
        dispatch(assignLabel(authToken, payload));
    }
    
    // uploading file in chat 
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        console.log('Selected file:', selectedFile);
    };
    
    // update lead data present on right section 
    const handleSubmitLead = async (payload) => {
        let companyNameReal, companyWebsiteReal;
        const payloadNew = await payload.map((obj) => {
            if (obj.type === "company") {
                companyNameReal = obj.values
            }
            if (obj.type === "company_website") {
                companyWebsiteReal = obj.values
            }
            if (obj?.options?.length > 0) {
                obj.values = obj?.values?.id?.toString() || null;
                obj.options = [];
            }
            const { id, display, ...rest } = obj;
            return rest;
        });
        let stageNum = await payloadNew.filter((item) => {
        if (item.type !== "calender") {
            return item;
        }
        });
        await dispatch(editUserData(authToken, lead_id_store, stageNum, companyNameReal, companyWebsiteReal, newId1, newId2));
        setEditDetail(false);
    }

    // adding data in lead details input dynamically     
    const handleDynamicFields = async (e, id, type, len) => {
        let data = [...user_detail_left];
        await data?.map((obj) => {
            // if (id === null && obj.display === "Name") {
            //     obj.values = e.target.value;
            //     setName(e.target.value);
            // }
            if (
                (type === "company" || type === "account_name") &&
                (obj.type === "company" || obj.type === "account_name")
            ) {
                obj.values = e.target.value;
            }
            if (
                (type === "company_website" || type === "account_website") &&
                (obj.type === "company_website" || obj.type === "account_website")
            ) {
                obj.values = e.target.value;
            }
            if (id === obj.id && len === 0) {
                obj.values = e.target.value;
            }
            if (id === obj.id && len !== 0) {
                obj.values = e;
            }
            return obj;
        });
        setUserData(data);
    };
    
    // const handleClose = () => {
    //     setTextValue("");
    //     setShow(false);
    // }
    
    
    // remove search data 
    const handleRemoveSearch = (e) => {
        setSearchValue("");
        dispatch(fetchSearchList(authToken, "", searchTabName, null, null, onSuccessSearch, onFailureSearch));
    };
    
    // add search data 
    const handleSearch = (e) => {
        setSearchValue(e.target.value);
        dispatch(fetchSearchList(authToken, e.target.value, searchTabName, null, null, onSuccessSearch, onFailureSearch));
    };

    // lead detail mode open and close 
    const handleEditorStatus = (value) => {
        setEditDetail(value);
    };
    
    // returns the cureent tab of inbox 
    const checkUrl = () => {
        let webUrl;
        if (window.location.pathname.includes("mine")) {
            webUrl = "mine";
        } else if (window.location.pathname.includes("unassigned")) {
            webUrl = "unassigned";
        } else {
            webUrl = "all";
        }
        return webUrl;
    }
    // adding the inbox and conversation id in url 
    const handleParamChange = (param1, param2) => { 
        const newParam1Value = param1;
        const newParam2Value = param2;
        let inboxCheck = params.get('inbox'); 
        let url = checkUrl();
        if (inboxCheck) {
            params.set('inbox', newParam1Value);
            params.set('conversation', newParam2Value);
            setInboxParam(newParam1Value);
            setConversationParam(newParam2Value);
            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.pushState({}, '', newUrl);
        } else {
            const newUrl = `/livechat/${window.location.pathname.includes("conversations")?"conversations":"mentions"}/${url}?inbox=${newParam1Value}&conversation=${newParam2Value}`;
            navigate(newUrl);
        }
    };
    
    // adding the query into the url 
    const handleQueryChange = async() => {
        let filter_value;
        if (initialFilter === "status") {
            filter_value = filterValue.name
        } else if (initialFilter === "assignee") {
            filter_value = filterValue.user_id
        } else if (initialFilter === "team") {
            filter_value = filterValue.team_id
        } else {
            filter_value = filterValue.tag_id
        }
        
        let filter_v = params.get('filter_v'); 
        console.log(filter_v);             
        if (filter_v && filter_v != "null" ) {
            params.set('filter_v', filter_value);
            params.set('filter_i', initialFilter);
            params.set('filter_o', filterOperator);
        } else {
            params.append('filter_v', filter_value);
            params.append('filter_i', initialFilter);
            params.append('filter_o', filterOperator);
        }
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.pushState({}, '', newUrl);
        setFilterPopup(false);
    };
    
    // on removing the query from the url 
    const removeQueryParameter = () => {
        params.delete('filter_v');
        params.delete('filter_i');
        params.delete('filter_o');
        const sort_value = params.get('sort');
        let tabValue;
        if (window?.location?.pathname?.includes("mine")) {
            tabValue = "assigned"
        } else if (window?.location?.pathname?.includes("unassigned")) {
            tabValue = "unassigned"
        } else {
            tabValue = "all"
        }
        // Update the URL without the specified query parameter
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.pushState({}, '', newUrl);
        dispatch(fetchLiveConversationListing(authToken, tabValue, null, null, null, sort_value, "none"))
    };

    // it return the count of search popup listing data 
    const getCount = (num, ind) => {
        if (ind === 0) {
        return num?.contacts
        } else {
        return num?.messages
        }
    }
    
    // displaying the first two character of full name 
    const getChars = (str) => {
        if (str === "") {
        return;
        }
        const firstLetters = str
        .split(" ")
        .slice(0, 2)
        .map((word) => word[0])
        .join("")
        .toUpperCase();
        return firstLetters;
    };

    // without updating the lead detail , closing the edit mode  
    const backToDetail = () => {
        setEditDetail(false);
    };
    
    // adding the new lead with validation 
    const submitHandler = async (e) => {
        e.preventDefault();
        let newLead;
        newLead = {
            action: "add",
            name: fname,
            company: company,
            company_website: companyWebsite,
            email: email,
            designation: designation,
            city: city,
            phone: phone,
            prospect_token: prospect_token || "",
            source: "LiveChat"
        };

        const regex =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (fname === "") {
        Toast("Please enter name", "E");
        } else if (email === "") {
        Toast("Please enter email", "E");
        } else if (regex.test(email) === false) {
        Toast("Please enter valid email", "E");
        } else if (phone === "") {
        Toast("Please enter mobile", "E");
        } else if (company === "") {
        Toast("Please enter company name", "E");
        } else if (companyWebsite === "") {
        Toast("Please enter company website", "E");
        } else if (!companyWebsite.includes(".")) {
        Toast("Please enter valid company website", "E");
        } else {
            await dispatch(addLeads(props.authToken, newLead, newId1, newId2));
            setOpenLeadPopup(false);
        }
    };
    
    // on successful response of search api 
    const onSuccessSearch = (value, count) => {
        setSearchListData(value);
        setSearchCount(count)
    }

    // on fail response of search api 
    const onFailureSearch = () => {
        console.log("fail")
    }
    
    return (
        <>
            <div className="flex w-full">
                <div className="w-full max-xl:w-full h-full">
                    <div className="h-full w-full flex">
                        {/* Activity feed */}
                        
                        {submenuOpen === true && <aside className="bg-white border-l border-r border-gray-200 h-full w-[13%]">
                            <ul className="w-full mb-3 pt-2">
                                {navigation?.map((item,index) => (
                                    <li key={item.name} className='cursor-pointer'>
                                        <span
                                        className={classNames(
                                            window?.location?.pathname?.includes(item.current)
                                            ? 'bg-gray-50 text-[var(--brand-primary)]'
                                            : 'text-[var(--brand-secondary)] hover:text-[var(--brand-primary)] hover:bg-gray-50',
                                            'group flex gap-x-4 max-xl:gap-x-2 rounded-md p-2 text-sm max-xl:text-xs leading-6 font-semibold'
                                        )}
                                        onClick={() => {
                                            navigate(item.href);
                                        }}
                                        >
                                        <item.icon
                                            className={classNames(
                                                window?.location?.pathname?.includes(item.current) ? 'text-[var(--brand-primary)]' : 'text-gray-400 group-hover:text-[var(--brand-primary)]',
                                            'h-5 w-5 max-xl:h-4 max-xl:w-4 shrink-0'
                                            )}
                                            aria-hidden="true"
                                        />
                                        {item.name}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                            
                            <div className="p-2">
                                <p className="flex rounded-md mb-2 text-base leading-6 font-medium">Teams</p>
                                <div className="max-h-[25vh] listing overflow-y-auto">                              
                                    {team_list?.length > 0 &&
                                        team_list?.map((team, t_ind) => {
                                            return (
                                                <div
                                                    onClick={() => {
                                                        setTeamId(team.team_id);
                                                        setTeamName(team.team_name);
                                                        setTeamDescription(team.team_description);
                                                        setTeamAgent(team?.team_detail);
                                                        setOpenTeam(true)
                                                    }}
                                                    key={t_ind}
                                                    className="mb-2 cursor-pointer items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900"
                                                >
                                                    <div className="flex gap-2">
                                                        {team.team_name}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setOpenTeam(true);
                                    }}
                                    className="rounded mr-2 mb-2 bg-white px-2 py-1 text-xs font-medium text-[var(--brand-primary)]"
                                >
                                    <PlusIcon
                                        className="h-3 w-3 inline"
                                        aria-hidden="true"
                                    />{" "}
                                    Add Team
                                </button>
                                
                            </div>
                            
                            <div className="p-2">
                                <p className="flex rounded-md mb-2 text-base leading-6 font-medium">Labels</p>
                                <div className="max-h-[25vh] listing overflow-y-auto">                              
                                    {label_list?.length > 0 &&
                                        label_list?.map((lab, l_ind) => {
                                            return (
                                                <div
                                                    onClick={() => {
                                                        setLabelName(lab.tag_name);
                                                        setLabelDescription(lab.tag_description);
                                                        setLabelColor(lab?.color_code);
                                                        setLabelId(lab.tag_id)
                                                        setOpen(true);
                                                    }}
                                                    key={l_ind}
                                                    className="mb-2 cursor-pointer items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900"
                                                >
                                                    <div className="flex gap-2">
                                                        <SquareFill style={{ color: lab?.color_code }} className={`h-3 w-3`} />
                                                        {lab.tag_name}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setOpen(true);
                                    }}
                                    className="rounded mr-2 mb-2 bg-white px-2 py-1 text-xs font-medium text-[var(--brand-primary)]"
                                >
                                    <PlusIcon
                                        className="h-3 w-3 inline"
                                        aria-hidden="true"
                                    />{" "}
                                    Add Label
                                </button>
                                
                            </div>
                        </aside>}
                        
                        <aside className="bg-gray-50 h-full w-[25%]">
                            <header className="flex items-center gap-3 justify-between border-b border-white/5 px-4 py-3">
                                <div className="w-[5%]">
                                    <TextLeft onClick={()=>{setSubmenuOpen(!submenuOpen)}} className="h-5 w-5 mr-2 text-gray-400 hover:text-[var(--brand-primary)] cursor-pointer"/>
                                </div>
                                <div className="w-[95%]">
                                    <div className="relative rounded-md shadow-sm my-auto max-sm:w-[50%]">
                                        <span onClick={() => {
                                            setShowSearchPopup(true);
                                        }} className="block cursor-pointer truncate text-sm bg-white text-gray-400 pl-3 overflow-hidden w-full rounded-md border-0 py-1.5 pr-8 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">{`Search for messages in ${window.location.pathname.includes("conversations") ? "conversation" : "mention"}`}</span>
                                        <div className="absolute z-[9] cursor-pointer right-2 top-1/4">
                                            {searchValue && searchValue !== "" ? (
                                                <X className="h-4 w-4 text-gray-400 pointer" onClick={handleRemoveSearch} />
                                            ) : (
                                                <MagnifyingGlassIcon className="h-4 w-4 text-gray-400 cursor-pointer" onClick={handleSearch} />
                                            )}
                                        </div>
                                    </div> 
                                </div>
                            </header>
                            <div className="text-xl px-4 py-0 flex justify-between items-center leading-6 font-semibold my-auto">
                                <div className="flex gap-3">
                                    <span>{window.location.pathname.includes("conversations")?"Conversations":"Mentions"}</span>
                                    <span className="inline-flex capitalize items-center rounded-md bg-yellow-50 px-2 py-0 text-[10px] font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                                        {listingStatus}
                                    </span>
                                </div>
                                <div className="flex items-center gap-4">
                                    {!urlFilterV ? <Funnel
                                        onClick={()=>{setFilterPopup(true)}}
                                        className="h-4 w-4 text-gray-400 hover:text-[var(--brand-primary)] cursor-pointer"
                                        aria-hidden="true"
                                    /> :
                                    <FunnelFill
                                        onClick={removeQueryParameter}
                                        title="Remove filter"
                                        className="h-4 w-4 text-[var(--brand-primary)] cursor-pointer"
                                        aria-hidden="true"
                                    />}
                                    <Menu as="div" className="relative inline-block text-left">
                                        <div>
                                            <Menu.Button className="flex items-center rounded-full bg-gray-100 text-gray-400 hover:text-gray-600">
                                            <span className="sr-only">Open options</span>
                                            <ArrowDownUp
                                                className="h-3.5 w-3.5 text-gray-400 hover:text-[var(--brand-primary)] cursor-pointer"
                                                aria-hidden="true"
                                            />
                                            </Menu.Button>
                                        </div>

                                        <Transition
                                            as={Fragment}
                                            enter="transition ease-out duration-100"
                                            enterFrom="transform opacity-0 scale-95"
                                            enterTo="transform opacity-100 scale-100"
                                            leave="transition ease-in duration-75"
                                            leaveFrom="transform opacity-100 scale-100"
                                            leaveTo="transform opacity-0 scale-95"
                                        >
                                            <Menu.Items className="absolute right-0 z-10 mt-2 w-64 origin-top-right rounded-md bg-gray-100 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <div>
                                                <div className="px-4 py-2 flex gap-2 items-center">
                                                    <label htmlFor="label" className="block w-[30%] text-xs font-medium leading-6 text-gray-900">
                                                        Status
                                                    </label>
                                                    <div className="w-[70%]">
                                                        <select
                                                            id="location"
                                                            name="location"
                                                            className="block w-full capitalize rounded-md border-0 py-0 font-normal pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-xs sm:leading-6"
                                                            value={filterNewValue}
                                                                onChange={(e) => {
                                                                setFilterNewValue(e.target.value);
                                                                const selectedId = e.target.value;
                                                                const selectedObject = statusFilter.find(option => option.name === selectedId);
                                                                setFilterValue(selectedObject);
                                                                let filter_v = params.get('filter_v');          
                                                                if (filter_v && filter_v != "null" ) {
                                                                    params.set('filter_v', selectedObject?.name);
                                                                    params.set('filter_i', "status");
                                                                    params.set('filter_o', "equals");
                                                                } else {
                                                                    params.append('filter_v', selectedObject?.name);
                                                                    params.append('filter_i', "status");
                                                                    params.append('filter_o', "equals");
                                                                }
                                                                const newUrl = `${window.location.pathname}?${params.toString()}`;
                                                                window.history.pushState({}, '', newUrl);
                                                            }}
                                                        >
                                                            {statusFilter.map((stat, s_ind) => {
                                                                return (
                                                                    <option key={stat.id} className="capitalize" value={stat.name}>{stat.name}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="px-4 py-1 pb-2 gap-2 flex items-center">
                                                    <label htmlFor="label" className="block w-[30%] text-xs font-medium leading-6 text-gray-900">
                                                        Order by
                                                    </label>
                                                    <div className="w-[70%]">
                                                        <select
                                                            id="location"
                                                            name="location"
                                                            className="block w-full rounded-md border-0 py-0 pl-3 pr-8 font-normal text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-xs sm:leading-6"
                                                            value={sortingValue}
                                                            onChange={(e) => {
                                                                let sort_data = params.get('sort'); 
                                                                let filter_v = params.get('filter_v');          
                                                                if (filter_v && filter_v != "null" ) {
                                                                    params.set('filter_v', filterNewValue);
                                                                    params.set('filter_i', "status");
                                                                    params.set('filter_o', "equals");
                                                                } else {
                                                                    params.append('filter_v', filterNewValue);
                                                                    params.append('filter_i', "status");
                                                                    params.append('filter_o', "equals");
                                                                }                                                                
                                                                setSortingValue(e.target.value);
                                                                if (sort_data && sort_data != "null" ) {
                                                                    params.set('sort', e.target.value);
                                                                } else {
                                                                    params.append('sort', e.target.value);
                                                                }
                                                                const newUrl = `${window.location.pathname}?${params.toString()}`;
                                                                window.history.pushState({}, '', newUrl);
                                                            }}    
                                                        >
                                                            <option value="last_activity_at_desc">
                                                                Last activity: Newest first
                                                            </option>    
                                                            <option value="last_activity_at_asc">
                                                                Last activity: Oldest first
                                                            </option>
                                                            <option value="created_at_desc">
                                                                Created at: Newest first
                                                            </option>
                                                            <option value="created_at_asc">
                                                                Created at: Oldest first
                                                            </option>
                                                            <option value="priority_desc">
                                                                Priority: Highest first
                                                            </option>
                                                            <option value="priority_asc">
                                                                Priority: Lowest first
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            </Menu.Items>
                                        </Transition>
                                    </Menu>
                                </div>
                            </div>

                            <div className="px-4 pt-2 flex justify-between mb-2">
                                <div className="text-base leading-6 font-semibold my-auto max-sm:w-full">
                                    <TabLiveChat
                                        tabs={tabs}
                                        setTabName={setTabName}
                                        tabName={tabName}
                                        count={live_chat_count}
                                        pathName={window.location.pathname.includes("conversations")?"conversations":"mentions"}
                                    />
                                </div>
                            </div>
                            <div className="conversations-list flex-1">
                                <ul className="w-full overflow-y-auto listing h-full px-3">
                                    {listingData?.length > 0 && listingData?.map((item) => (
                                        <li
                                            key={item?.conversation_id}
                                            className={`col-span-12 cursor-pointer divide-y mb-3 ${(item?.inbox_id == inboxParam || item?.inbox_id == newId1) ? "bg-[color-mix(in_srgb,var(--brand-primary)_19%,transparent)]":"bg-white"} divide-gray-200 hover:rounded-none rounded-lg shadow`}
                                            onClick={() => {
                                                handleParamChange(item?.inbox_id, item.conversation_id);
                                            }}
                                        >
                                            <div className="relative w-full items-center justify-between p-4">
                                                <div className="flex items-center gap-4">
                                                    <div>
                                                        <div
                                                            className="bg-[var(--brand-primary)] relative text-center text-white p-[0.4rem] w-9 rounded-full"
                                                            title={item?.lead_name}
                                                        >
                                                            {getChars(item?.lead_name || "Unknown")}
                                                            {/* <CircleFill className="text-green-700 border border-white rounded-full absolute right-[-4px] bottom-[-4px]"/> */}
                                                        </div>
                                                    </div>
                                                    <div className="w-[70%]">
                                                        <div className="flex space-x-4">
                                                            <div className="flex-1 truncate">
                                                                <div className="flex items-center space-x-3">
                                                                    <h3 className="truncate text-sm font-medium text-gray-900">
                                                                        {item?.lead_name || "Unknown"}
                                                                    </h3>
                                                                    <span className="inline-flex capitalize flex-shrink-0 items-center rounded-md bg-[color-mix(in_srgb,var(--brand-primary)_13%,transparent)] px-1.5 py-0.5 text-[10px] font-medium text-[var(--brand-primary)] ring-1 ring-inset ring-green-600/20">
                                                                        {item?.channel_name}
                                                                    </span>
                                                                </div>
                                                                <p className="mt-1 truncate text-xs text-gray-500">
                                                                    {item?.last_message}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <span className="absolute right-3 italic text-gray-600 top-4 text-[9px] font-medium">
                                                            {item?.user_last_seen}
                                                        </span>
                                                        
                                                        {item?.message_count > 0 && <span className="absolute right-3 bg-[var(--brand-primary)] px-1.5 text-center rounded-full text-white non-italic top-1/2 text-[10px] font-medium">
                                                            {item?.message_count}
                                                        </span>}
                                                        
                                                        {item?.tag_data?.length > 0 && <div className="m-0 mt-2">
                                                            {item.tag_data?.map((tag,t_ind) => {
                                                                return (
                                                                    <>
                                                                        {t_ind < 1 && <div key={t_ind} className='px-2 mr-2 py-0 w-auto rounded-md inline-flex gap-2 bg-transparent text-[var(--brand-secondary)] border border-gray-400 items-center text-xs'>
                                                                            <SquareFill style={{ color: tag.color_code}} className={`h-2 w-2`} />
                                                                                {tag.tag_name}
                                                                        </div>}
                                                                    </>
                                                                );
                                                            })}
                                                            {item?.tag_data?.length-1 > 0 && <span className="text-xs text-gray-500">+ {item?.tag_data?.length - 1}</span>}
                                                        </div>}
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </aside>

                        <main className="flex flex-col w-[40%] justify-between border-l border-r border-gray-200 flex-grow h-full min-w-0 m-0">
                            {(!newId1 || !newId2) ? <div className="bg-gray-100 h-full w-full flex items-center justify-center">
                                <div className="text-center">
                                    <img className="h-20 w-20 m-auto" src={Looking} alt="looking" />
                                    <p className="text-xs text-[var(--brand-secondary)] font-semibold">Please select a conversation from left pane</p>
                                </div>
                            </div> : 
                            <InboxContainer displayType="1" inboxParam={inboxParam || newId1} conversationParam={conversationParam || newId2} pageName="liveChat" subPageName="chat" fetchQueryParams={fetchQueryParams} authToken={authToken} /> }
                        </main>

                        {/* Activity feed */}
                        {(newId1 && newId2) && <aside ref={dropdownRef} className="conversation-sidebar-wrap bg-gray-50 listing p-4 w-[22%] basis-full sm:basis-[17.5rem] md:basis-[18.75rem] lg:basis-[19.375rem] xl:basis-[20.625rem] 2xl:basis-[25rem] rtl:border-r border-slate-50 dark:border-slate-700 h-auto overflow-auto z-0 flex-grow-0">
                            <div className="bg-gray-50 text-slate-900 dark:text-slate-300 dark:border-slate-800/50 contact--panel">
                                <div className="col-span-1 mb-4 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-left shadow">
                                    {/* <header className="flex items-center justify-between border-b border-white/5 py-2 px-4">
                                        <h2 className="text-base font-medium leading-7 text-gray-900">
                                            Lead Info
                                        </h2>
                                        {detailMinimize === true && (
                                            <>
                                                {editDetail !== true ? (
                                                    <>
                                                        <span
                                                            onClick={() => {
                                                                handleEditorStatus(true);
                                                            }}
                                                            className="flex ml-auto mr-0 items-center justify-center border hover:text-[var(--brand-primary)] hover:border-[var(--brand-primary)] border-gray-300 px-2.5 py-1 rounded-md border-solid cursor-pointer "
                                                        >
                                                            <Pencil className="cursor-pointer text-gray-600 text-[16px]" />
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span
                                                            onClick={backToDetail}
                                                            className="flex ml-auto mr-1 items-center justify-center border hover:text-[var(--brand-primary)] border-[gray] px-2.5 py-1 rounded-md border-solid cursor-pointer "
                                                        >
                                                            <X className="cursor-pointer text-[gray] text-[16px]" />
                                                        </span>
                                                        <span
                                                            className="flex items-center justify-center border hover:text-[var(--brand-primary)] border-[green] px-2.5 py-1 rounded-md border-solid cursor-pointer "
                                                        >
                                                            <Check2 className="cursor-pointer text-[green] text-[16px]" />
                                                        </span>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </header> */}
                                    <div className="flex flex-1 flex-col p-4">
                                        <div
                                            className={
                                                "relative flex items-center space-x-1 rounded-lg mb-4 border border-gray-100 bg-white px-2 py-2 shadow-sm"
                                            }
                                        >
                                            <div
                                                className="bg-[var(--brand-primary)] text-white w-[35px] text-center p-[0.4rem] rounded-full"
                                                title={user_detail?.name}
                                            >
                                                {getChars(user_detail?.name || "Unknown")}
                                            </div>
                                            <div className="min-w-0 flex-1">
                                                <div
                                                    className="pl-1"
                                                    // onClick={() => {
                                                    //     setDetailMinimize(!detailMinimize);
                                                    // }}
                                                >
                                                    <span aria-hidden="true" />
                                                    <p className="text-sm font-medium text-gray-900">
                                                        {user_detail?.name || "Unknown"}
                                                    </p>
                                                    {(lead_id_store !== null && user_detail?.designation !== "") && <p className="truncate text-sm text-gray-500">
                                                        {user_detail?.designation}
                                                    </p>}
                                                </div>
                                            </div>
                                            {lead_id_store !== null && <>
                                            {editDetail !== true ? (
                                                    <>
                                                        <span
                                                            onClick={() => {
                                                                handleEditorStatus(true);
                                                            }}
                                                            className="flex ml-auto mr-0 items-center justify-center border hover:text-[var(--brand-primary)] hover:border-[var(--brand-primary)] border-gray-300 px-1.5 py-1 rounded-md border-solid cursor-pointer "
                                                        >
                                                            <Pencil className="cursor-pointer text-gray-600 text-[12px]" />
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span
                                                            onClick={backToDetail}
                                                            className="flex ml-auto mr-1 items-center justify-center border hover:text-[var(--brand-primary)] border-[gray] px-1.5 py-1 rounded-md border-solid cursor-pointer "
                                                        >
                                                            <X className="cursor-pointer text-[gray] text-[12px]" />
                                                        </span>
                                                        <span
                                                            className="flex items-center justify-center border hover:text-[var(--brand-primary)] border-[green] px-1.5 py-1 rounded-md border-solid cursor-pointer "
                                                            onClick={() => { handleSubmitLead(userData) }}
                                                        >   
                                                            <Check2 className="cursor-pointer text-[green] text-[12px]" />
                                                        </span>
                                                    </>
                                                )}
                                            </>}
                                        </div>

                                        {/* lead detailed */}
                                        {lead_id_store !== null ? <div className="h-[22vh] listing overflow-y-auto">
                                            {userData?.length > 0 &&
                                                userData?.map((data, d_index) => {
                                                    return (
                                                        <>
                                                            {data.object_type === "leads" &&
                                                                (editDetail !== false ||
                                                                    (data.values &&
                                                                        data.values !== "" &&
                                                                        data.values !== null)) && (
                                                                    <div key={d_index} className="mb-3 lh-lg details-section">
                                                                        <div className="text-xs leading-4 font-semibold text-[var(--brand-secondary)]">
                                                                            {data.display}
                                                                        </div>
                                                                        <div className="grid grid-cols-12">
                                                                            {editDetail !== true ? (
                                                                                <div className="h-[25px] col-span-8 text-sm leading-5 font-normal text-gray-900">
                                                                                    {data?.options?.length > 0
                                                                                        ? data?.values?.option_value
                                                                                        : data.values}
                                                                                </div>
                                                                            ) : (
                                                                                <div className="h-auto col-span-9 fw-normal">
                                                                                    <div>
                                                                                        {data?.options?.length === 0 ? (
                                                                                            <input
                                                                                                className="w-full text-sm leading-5 font-normal text-gray-900"
                                                                                                type={data.type}
                                                                                                value={data.values}
                                                                                                onChange={(e) => {
                                                                                                      handleDynamicFields(
                                                                                                        e,
                                                                                                        data.id,
                                                                                                        data.type,
                                                                                                        data?.options?.length
                                                                                                      );
                                                                                                }}
                                                                                            />
                                                                                        ) : (
                                                                                            <>
                                                                                                <div className="w-full text-sm leading-5 font-normal text-gray-900">
                                                                                                    <Listbox
                                                                                                        value={data.values}
                                                                                                        onChange={(e) => {
                                                                                                            handleDynamicFields(
                                                                                                                e,
                                                                                                                data.id,
                                                                                                                data.type,
                                                                                                                data?.options?.length
                                                                                                            );
                                                                                                        }}
                                                                                                    >
                                                                                                        {({ open }) => (
                                                                                                            <>
                                                                                                                <div className="relative">
                                                                                                                    <Listbox.Button className="relative h-[25px] mr-[5px] rounded-none border-b-[#ced4da] border-b border-solid w-full bg-white text-left text-gray-900 shadow-sm focus:outline-none cursor-pointer sm:text-sm sm:leading-6">
                                                                                                                        <span className="block truncate">
                                                                                                                            {
                                                                                                                                data?.values
                                                                                                                                    ?.option_value
                                                                                                                            }
                                                                                                                        </span>
                                                                                                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                                                                                            <ChevronDownIcon
                                                                                                                                className="h-4 w-4 text-gray-400"
                                                                                                                                aria-hidden="true"
                                                                                                                            />
                                                                                                                        </span>
                                                                                                                    </Listbox.Button>

                                                                                                                    <Transition
                                                                                                                        show={open}
                                                                                                                        as={Fragment}
                                                                                                                        leave="transition ease-in duration-100"
                                                                                                                        leaveFrom="opacity-100"
                                                                                                                        leaveTo="opacity-0"
                                                                                                                    >
                                                                                                                        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full listing overflow-auto rounded-md h-[25vh] bg-[#f5f5f5] py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                                                                                            {data?.options?.map(
                                                                                                                                (option) => (
                                                                                                                                    <Listbox.Option
                                                                                                                                        key={
                                                                                                                                            option.id
                                                                                                                                        }
                                                                                                                                        className={({
                                                                                                                                            active,
                                                                                                                                        }) =>
                                                                                                                                            classNames(
                                                                                                                                                active
                                                                                                                                                    ? "bg-[var(--brand-primary)] text-white"
                                                                                                                                                    : "text-gray-900",
                                                                                                                                                "relative cursor-default select-none py-2 pl-2 pr-4"
                                                                                                                                            )
                                                                                                                                        }
                                                                                                                                        value={
                                                                                                                                            option
                                                                                                                                        }
                                                                                                                                    >
                                                                                                                                        {({
                                                                                                                                            selected,
                                                                                                                                            active,
                                                                                                                                        }) => (
                                                                                                                                            <>
                                                                                                                                                <span
                                                                                                                                                    className={classNames(
                                                                                                                                                        selected
                                                                                                                                                            ? "font-semibold"
                                                                                                                                                            : "font-normal",
                                                                                                                                                        "block truncate"
                                                                                                                                                    )}
                                                                                                                                                >
                                                                                                                                                    {
                                                                                                                                                        option.option_value
                                                                                                                                                    }
                                                                                                                                                </span>
                                                                                                                                            </>
                                                                                                                                        )}
                                                                                                                                    </Listbox.Option>
                                                                                                                                )
                                                                                                                            )}
                                                                                                                        </Listbox.Options>
                                                                                                                    </Transition>
                                                                                                                </div>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </Listbox>
                                                                                                </div>
                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                        </>
                                                    );
                                                })}
                                        </div> : 
                                        <button
                                            type="button"
                                            onClick={()=>{setOpenLeadPopup(true)}}    
                                            className="rounded bg-[color-mix(in_srgb,var(--brand-primary)_19%,transparent)] px-2 py-1 text-xs font-semibold text-[var(--brand-primary)] shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_31%,transparent)]"
                                        >
                                            Add Lead
                                        </button>
                                        }
                                        {/* lead detailed */}
                                    </div>
                                </div>

                                <div className="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white text-left shadow">
                                <header className="flex items-center justify-between border-b border-white/5 py-1 px-4">
                                    <h2 className="text-sm font-medium leading-7 text-gray-900">
                                        Conversation Actions
                                    </h2>
                                    <span
                                        onClick={() => {
                                            setDetailMinimize(!detailMinimize);
                                        }}
                                        className="flex ml-auto mr-0 items-center justify-center border px-1.5 py-1 rounded-md border-solid cursor-pointer "
                                    >
                                        {detailMinimize === false ?<Plus className="cursor-pointer text-gray-600 text-[12px]" /> :
                                        <Dash className="cursor-pointer text-gray-600 text-[12px]" />}
                                    </span>
                                </header>
                                {detailMinimize === true &&<div className="p-4 py-2">
                                        <Listbox
                                            value={selected}
                                            onChange={(e) => {
                                                let payload = {
                                                    inbox_id: newId1,
                                                    conversation_id: newId2,
                                                    assignee_id: e.user_id,
                                                    assignee_name: e.value,
                                                }
                                                dispatch(assignConversationLead(authToken,payload, newId1, newId2))
                                                setSelected(e)
                                            }}
                                        >
                                        {({ open }) => (
                                            <>
                                                <Listbox.Label className="text-sm leading-4 font-semibold text-[var(--brand-secondary)]">
                                                    Assigned Agent
                                                </Listbox.Label>
                                                <div className="relative mt-1 mb-4">
                                                    <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                                                        <span className="block truncate">
                                                            {selected?.first_name ? selected?.first_name+" "+selected?.last_name : "Select Agent"}
                                                        </span>
                                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                            <ChevronDownIcon
                                                                className="h-5 w-5 text-gray-400"
                                                                aria-hidden="true"
                                                            />
                                                        </span>
                                                    </Listbox.Button>

                                                    <Transition
                                                        show={open}
                                                        as={Fragment}
                                                        leave="transition ease-in duration-100"
                                                        leaveFrom="opacity-100"
                                                        leaveTo="opacity-0"
                                                    >
                                                        <Listbox.Options className="absolute z-10 mt-1 max-h-32 listing w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                            {assignAgentList?.length > 0 && assignAgentData?.map((person) => (
                                                                <Listbox.Option
                                                                    key={person.user_id}
                                                                    className={({ active }) =>
                                                                        classNames(
                                                                            active
                                                                                ? "bg-gray-100 text-gray-900"
                                                                                : "text-gray-900",
                                                                            "relative cursor-pointer select-none py-2 pl-3 pr-9"
                                                                        )
                                                                    }
                                                                    disabled={person.agent_status !== 1}
                                                                    value={person}
                                                                >
                                                                    {person.agent_status !== 1 && <span className="absolute bg-[#00000020] z-20 top-0 bottom-0 w-full left-0"></span>}
                                                                    <span
                                                                        className={classNames(
                                                                            person?.user_id === selected?.user_id
                                                                                ? "font-semibold"
                                                                                : "font-normal",
                                                                            "truncate flex capitalize items-center gap-2"
                                                                        )}
                                                                    >
                                                                    <div
                                                                        className="bg-[var(--brand-primary)] relative font-normal text-center text-white p-1 w-7 h-7 rounded-full"
                                                                    >
                                                                        {getChars(person.first_name +" "+ person.last_name)}
                                                                        <CircleFill className={`${person?.agent_status == 1 ? "text-green-700": person?.agent_status == 3 ? "text-gray-500":"text-yellow-500"} border border-white h-2.5 w-2.5 rounded-full absolute right-[-1px] bottom-[-1px]`} />
                                                                    </div>
                                                                        {person.first_name +" "+ person.last_name}
                                                                    </span>

                                                                        {person?.user_id == selected?.user_id && <span
                                                                            className="absolute inset-y-0 right-0 flex items-center pr-4"
                                                                        >
                                                                            <CheckIcon
                                                                                className={`h-5 w-5 hover:text-white text-[var(--brand-primary)]`}
                                                                                aria-hidden="true"
                                                                            />
                                                                        </span>}
                                                                </Listbox.Option>
                                                            ))}
                                                        </Listbox.Options>
                                                    </Transition>
                                                </div>
                                            </>
                                        )}
                                    </Listbox>

                                    <Listbox
                                        value={selectedPriority}
                                        onChange={(e) => {
                                            let payload = {
                                                inbox_id: newId1,
                                                channel_id: "1",
                                                conversation_id: newId2,
                                                conversation_status: e.id,
                                                priority: e.name,
                                            }
                                            dispatch(assignConversationLead(authToken,payload, newId1, newId2))
                                            setSelectedPriority(e)
                                        }}    
                                    >
                                        {({ open }) => (
                                            <>
                                                <Listbox.Label className="text-sm leading-4 font-semibold text-[var(--brand-secondary)]">
                                                    Priority
                                                </Listbox.Label>
                                                <div className="relative mt-1 mb-4">
                                                    <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6">
                                                        <span className="block truncate">
                                                            {selectedPriority?.name || "Select Priority"}
                                                        </span>
                                                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                            <ChevronDownIcon
                                                                className="h-5 w-5 text-gray-400"
                                                                aria-hidden="true"
                                                            />
                                                        </span>
                                                    </Listbox.Button>

                                                    <Transition
                                                        show={open}
                                                        as={Fragment}
                                                        leave="transition ease-in duration-100"
                                                        leaveFrom="opacity-100"
                                                        leaveTo="opacity-0"
                                                    >
                                                        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                                            {priorityData?.map((person) => (
                                                                <Listbox.Option
                                                                    key={person.id}
                                                                    className={({ active }) =>
                                                                        classNames(
                                                                            active
                                                                                ? "bg-gray-100 text-gray-900"
                                                                                : "text-gray-900",
                                                                            "relative cursor-default select-none py-2 pl-3 pr-9"
                                                                        )
                                                                    }
                                                                    value={person}
                                                                >
                                                                    {({ selected, active }) => (
                                                                        <>
                                                                            <span
                                                                                className={classNames(
                                                                                    selected
                                                                                        ? "font-semibold"
                                                                                        : "font-normal",
                                                                                    "flex items-center gap-2 truncate"
                                                                                )}
                                                                            >
                                                                                <person.icon style={{color:person.color}} className="h-4 w-4"/>
                                                                                {person.name}
                                                                            </span>

                                                                            {selected ? (
                                                                                <span
                                                                                    className={classNames(
                                                                                        active
                                                                                            ? "text-[var(--brand-primary)]"
                                                                                            : "text-[var(--brand-primary)]",
                                                                                        "absolute inset-y-0 right-0 flex items-center pr-4"
                                                                                    )}
                                                                                >
                                                                                    <CheckIcon
                                                                                        className="h-5 w-5"
                                                                                        aria-hidden="true"
                                                                                    />
                                                                                </span>
                                                                            ) : null}
                                                                        </>
                                                                    )}
                                                                </Listbox.Option>
                                                            ))}
                                                        </Listbox.Options>
                                                    </Transition>
                                                </div>
                                            </>
                                        )}
                                    </Listbox>

                                    <div>
                                        <span className="text-sm leading-4 font-semibold text-[var(--brand-secondary)]">
                                            Conversation Labels
                                        </span>

                                        <div className="mt-2 gap-2">
                                            {/* <Select
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                closeMenuOnSelect={false}
                                                components={animatedComponents}
                                                defaultValue={agentLabel}
                                                isMulti
                                                options={labelData}
                                                onChange={(e) => {
                                                    setAgentLabel(e);
                                                }}    
                                            /> */}
                                                {fetch_tag_data?.length > 0 && fetch_tag_data?.map((tag, t_index) => {
                                                    return (
                                                        <div key={t_index} className='px-2 mr-2 mb-2 py-0.5 w-auto rounded-md inline-flex gap-2 bg-white text-[var(--brand-secondary)] border-[3px] border-gray-300 items-center text-xs'>
                                                            <SquareFill style={{ color: tag?.color_code }} className={`h-2 w-2`} />
                                                            { tag?.tag_name }
                                                            <XMarkIcon className={`h-4 w-4 cursor-pointer`} onClick={()=>{handleRemoveAssign(tag)}} />
                                                        </div>
                                                    );
                                                })}
                                            <Menu as="div" className="relative text-left">
                                                <div>
                                                    <Menu.Button onClick={(e)=>{setDropControl(e.target)}} className="inline-flex w-auto justify-center rounded-md bg-[var(--brand-primary)] px-3 py-1 text-xs font-semibold text-white shadow-sm">
                                                        + Add Label
                                                    </Menu.Button>
                                                </div>

                                                <Transition
                                                    as={Fragment}
                                                    enter="transition ease-out duration-100"
                                                    enterFrom="transform opacity-0 scale-95"
                                                    enterTo="transform opacity-100 scale-100"
                                                    leave="transition ease-in duration-75"
                                                    leaveFrom="transform opacity-100 scale-100"
                                                    leaveTo="transform opacity-0 scale-95"
                                                >
                                                    <Menu.Items className="relative bg-gray-100 left-0 z-10 mt-2 w-full origin-top-left divide-y divide-gray-300 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                    <div className="px-4 py-3">
                                                        <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                                            Add label
                                                        </label>
                                                        <div className="mt-2">
                                                            <input
                                                                type="text"
                                                                name="label"
                                                                id="label"
                                                                value={labelSearch}    
                                                                onChange={(e)=>{setLabelSearch(e.target.value)}}           
                                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                                                placeholder="Search label ..."
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="max-h-[20vh] listing overflow-y-auto">
                                                        {labelData?.map((label,l_ind) => {
                                                            return (
                                                                <div className="py-1" key={l_ind}>
                                                                    <Menu.Item>
                                                                    {({ active }) => (
                                                                        <div 
                                                                            onClick={() => {
                                                                                let payload = {
                                                                                    inbox_id: newId1,
                                                                                    conversation_id: newId2,
                                                                                    tag_id: label?.tag_id,
                                                                                    status: "added"
                                                                                }
                                                                                dispatch(assignLabel(authToken, payload));                                                                                   
                                                                            }}        
                                                                            className={classNames(
                                                                            active ? 'bg-white text-gray-900' : 'text-[var(--brand-secondary)]',
                                                                            'px-4 py-2 flex gap-2 items-center text-sm cursor-pointer'
                                                                            )}
                                                                        >
                                                                            <SquareFill style={{ color: label?.color_code }} className={`h-3 w-3`} />
                                                                            {label.tag_name}    
                                                                        </div>        
                                                                    )}
                                                                    </Menu.Item>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>        
                                                            
                                                    <div className="px-4 py-1">
                                                        <button
                                                            type="button"
                                                            onClick={() => {
                                                                setOpen(true);
                                                            }}
                                                            className="rounded border border-gray-300 bg-[var(--brand-primary)] py-1 hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] w-full text-xs font-semibold text-white shadow-sm"
                                                        >
                                                            Create Label
                                                        </button>
                                                    </div>
                                                    </Menu.Items>
                                                </Transition>
                                            </Menu>                                              
                                        </div>
                                    </div>
                                </div>}
                                </div>
                            </div>
                        </aside>}
                    </div>
                </div>
            </div>
            
            {/* add team popup4 */}
            
            <Transition.Root show={openTeam} as={Fragment}>
                <Dialog as="div" className="relative z-10"
                    onClose={() => {
                        setOpenTeam(false);
                        setTimeout(() => {
                            setTeamId(null);
                        }, 1000);
                    }}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                            <div>
                                <p className="flex text-lg leading-6 font-medium border-b pb-2 border-gray-200 mb-2">{teamId === null ? "Add" : "Update"} Team</p> 
                                {(globalError) && <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
                                    Please fill all the required fields
                                </span>}                                          
                                <div className="mt-2">
                                    <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                        Team Name
                                    </label>
                                    <div>
                                        <input
                                            type="text"
                                            name="label"
                                            id="label"
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder="Team Name"
                                            value={teamName}
                                            onChange={(e)=>{setTeamName(e.target.value)}}
                                        />
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">
                                        Team Description
                                    </label>
                                    <div>
                                        <input
                                            type="text"
                                            name="description"
                                            id="description"
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder="Team Description"
                                            value={teamDescription}
                                            onChange={(e)=>{setTeamDescription(e.target.value)}}
                                        />
                                    </div>
                                </div>
                                        
                                <div className="mt-2">
                                    <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">
                                        Add Agents
                                    </label>
                                    <Select
                                        closeMenuOnSelect={false}
                                        components={animatedComponents}
                                        value={teamAgent}
                                        isMulti
                                        options={assignAgentList}
                                        onChange={(e) => {
                                            // let payload = {
                                            //     inbox_id: newId1,
                                            //     conversation_id: newId2,
                                            //     tag_id: e,
                                            //     status: "added" //added, removed
                                            // }
                                            // assignLabel(authToken)    
                                            setTeamAgent(e)
                                        }} 
                                    />
                                </div>
                                        
                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                                            onClick={() => {
                                                if (teamName !== "" && teamDescription !== "" && teamAgent?.length > 0) {
                                                    setGlobalError(false);
                                                    dispatch(createTeam(authToken, teamName, teamDescription, teamAgent, teamId));
                                                    setTeamName("");
                                                    setTeamDescription("");
                                                    setTeamAgent([]);
                                                    setTimeout(() => {
                                                        setTeamId(null);
                                                    }, 1000);
                                                    setOpenTeam(false);
                                                } else {
                                                    setGlobalError(true);
                                                }    
                                            }}
                                        >
                                            {teamId === null ? "Create":"Update"}
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            onClick={() => {
                                                setTimeout(() => {
                                                    setTeamId(null);
                                                }, 1000);    
                                                setTeamName("");
                                                setTeamDescription("");
                                                setTeamAgent([]);
                                                setGlobalError(false);
                                                setOpenTeam(false)
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                            </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
            
            {/* add label popup */}
            
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10"
                    onClose={() => {
                        setOpen(false);
                        setTimeout(() => {
                            setLabelId(null);
                        }, 1000);
                    }}
                >
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                            <div>
                                <p className="flex text-lg leading-6 font-medium">{labelId === null ? "Add":"Update"} label</p>    
                                <p className="flex border-b pb-2 border-gray-200 mb-2 text-xs">Labels let you group the conversations together.</p>
                                {(globalError) && <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
                                       Please fill all the required fields
                                </span>}                                       
                                <div className="mt-2">
                                    <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                        Label Name
                                    </label>
                                    <div>
                                        <input
                                            type="text"
                                            name="label"
                                            id="label"
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder="Label Name"
                                            value={labelName}
                                            onChange={(e)=>{setLabelName(e.target.value)}}
                                        />
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">
                                        Description
                                    </label>
                                    <div>
                                        <input
                                            type="text"
                                            name="description"
                                            id="description"
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder="Label Description"
                                            value={labelDescription}
                                            onChange={(e)=>{setLabelDescription(e.target.value)}}
                                        />
                                    </div>
                                </div>
                                        
                                <div className="mt-2">
                                    <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">
                                        Color
                                    </label>
                                    <div>
                                        <input
                                            type="color"
                                            name="description"
                                            id="description"
                                            className="text-gray-900 sm:text-sm"
                                            placeholder="Label Description"
                                            value={labelColor}
                                            onChange={(e) => {
                                                setLabelColor(e.target.value)
                                            }}
                                        />
                                    </div>
                                        </div>
                                        
                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                                            onClick={() => {
                                                if (labelName !== "" && labelDescription !== "") {
                                                    setGlobalError(false)
                                                    dispatch(createLabel(authToken, labelName, labelDescription, labelColor, labelId));
                                                    setLabelName("");
                                                    setLabelDescription("");
                                                    setLabelColor("#59adbc");
                                                    setOpen(false)
                                                    setTimeout(() => {
                                                        labelId(null);
                                                    }, 1000);
                                                } else {
                                                    setGlobalError(true)
                                                }
                                            }}
                                        >
                                            {labelId === null ? "Create":"Update"}
                                        </button>
                                        <button
                                            type="button"
                                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                            onClick={() => {
                                                setTimeout(() => {
                                                    labelId(null);
                                                }, 1000);
                                                setLabelName("");
                                                setLabelDescription("");
                                                setLabelColor("#59adbc");
                                                setGlobalError(false);
                                                setOpen(false)
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                            </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
            
            {/* full screen input mode */}
            
            <Transition.Root show={show} as={Fragment}>
                <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={()=>{if(assistPop === false){setShow(false)}}}>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className={`relative transform overflow-hidden border p-1 max-sm:w-full rounded-lg text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl ${editorStatus !== "note" ? "bg-[#f2f2f2] border-gray-300":"bg-yellow-100 border-yellow-300"}`}>
                            <div className={""}>
                            {/* {viewModal !== false && <h3 className="not-italic text-center mb-3 font-bold text-2xl leading-[29px] text-[#00000094]">{ "Preview" }</h3>} */}
                            <div className="d-flex flex-column popup-emoji">
                                <div className="w-full">
                                {/* <textarea
                                    ref={textareaRef}
                                    value={textValue}
                                    placeholder={`${editorStatus !== "note" ? "Shift + enter for new line. Start with '/' to select a Canned Response.":"Shift + enter for new line."}...`}
                                    className={`w-full h-[65vh] border-none inputBorder p-3 resize-none ${editorStatus !== "note" ? "bg-white":"bg-yellow-50"}`}
                                    onChange={(e)=>{ setTextValue(e.target.value) }}
                                    // disabled={viewModal === true}  
                                /> */}
                                    <EmojiTextArea value={text} className="listing" onChange={setText} onEmojiClick={handleEmojiClick} />
                                </div>
                                <div className="flex justify-between p-2">
                                    <div className="flex items-center space-x-5">
                                        <div className="flex justify-center shadow-md border border-gray-300 rounded-lg">
                                            <button onClick={()=>{setEditorStatus("reply")}} className={`px-3 py-1 ${editorStatus !== "note" ? "bg-[var(--brand-primary)] text-white hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)]": "bg-white text-[var(--brand-primary)] hover:bg-gray-100"} text-xs font-normal rounded-l-lg focus:outline-none`}>
                                                Reply
                                            </button>
                                            <button onClick={()=>{setEditorStatus("note")}} className={`px-3 py-1 ${editorStatus !== "reply" ? "bg-[var(--brand-primary)] text-white hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)]": "bg-white text-[var(--brand-primary)] hover:bg-gray-100"} text-xs font-normal rounded-r-lg focus:outline-none`}>
                                                Private Note
                                            </button>
                                        </div>        
                                        <div className="flex items-center">
                                            <button
                                            type="button"
                                            onClick={()=>{setShow(true)}}            
                                            className="-m-2.5 flex h-10 w-10 items-center justify-center rounded-full text-gray-400 hover:text-gray-500"
                                            >
                                            <Fullscreen className="h-4 w-4" aria-hidden="true" />
                                            <span className="sr-only">Maximize</span>
                                            </button>
                                        </div>
                                        <div className="flex items-center">
                                            <button
                                                type="button"
                                                onClick={handleButtonClick}        
                                                className="-m-2.5 flex h-10 w-10 items-center justify-center rounded-full text-gray-400 hover:text-gray-500"
                                            >
                                            <PaperClipIcon className="h-5 w-5" aria-hidden="true" />
                                            <span className="sr-only">Attach a file</span>
                                            </button>
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                onChange={handleFileChange}
                                                style={{ display: 'none' }} // Hide the input element
                                            />
                                        </div>
                                        <div className="flex items-center">
                                            <button onClick={()=>{setAssistPop(true)}} className="button-color relative rounded bg-indigo-50 px-2 py-1 text-xs font-medium shadow-sm hover:bg-indigo-100">
                                                <span className="absolute -right-1 -top-1 flex h-3 w-3">
                                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[var(--brand-primary)] opacity-75"></span>
                                                    <span className="relative opacity-60 inline-flex rounded-full h-3 w-3 bg-[var(--brand-primary)]"></span>
                                                </span>
                                                <span className="button__content flex gap-1 text-left rtl:text-right">
                                                    <Magic/>AI Assist
                                                </span>
                                            </button>
                                        </div>
                                    </div>                
                                    <button
                                        type="submit"
                                        className="inline-flex items-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                                    >
                                        <Send/>
                                    </button>
                                </div>
                            </div>
                            </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
            
            {/* AI assist popup */}
            
            <Transition.Root show={assistPop} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setAssistPop}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl sm:p-6">
                            <div>
                                <p className="flex text-lg leading-6 font-medium">AI Assist</p>    
                                <p className="flex border-b pb-2 border-gray-200 mb-2 text-xs">Change the text as per the requirement.</p>                                        
                                <div className="mt-2">
                                    <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                        Original Message
                                    </label>
                                    <div>
                                        {/* <input
                                            type="text"
                                            name="label"
                                            id="label"
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder="Type message here..."
                                            value={labelName}
                                            onChange={(e)=>{setLabelName(e.target.value)}}
                                        /> */}
                                        <textarea
                                            rows={3}
                                            autoFocus        
                                            name="comment"
                                            id="comment"
                                            placeholder="Type message here..."
                                            className="block w-full rounded-md resize-none border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset listing focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            defaultValue={''}
                                        />
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                        Select AI Action
                                    </label>     
                                    <Menu as="div" className="relative w-full inline-block text-left">
                                        <div>
                                            <Menu.Button className={`inline-flex w-full justify-between gap-x-1.5 rounded-md ${assistAction !== "" ? "text-gray-900":"text-gray-400"} bg-white px-3 py-2 text-sm font-medium shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50`}>
                                                {assistAction !== "" ? assistAction : "Select the action ..."}
                                            <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                                            </Menu.Button>
                                        </div>

                                        <Transition
                                            as={Fragment}
                                            enter="transition ease-out duration-100"
                                            enterFrom="transform opacity-0 scale-95"
                                            enterTo="transform opacity-100 scale-100"
                                            leave="transition ease-in duration-75"
                                            leaveFrom="transform opacity-100 scale-100"
                                            leaveTo="transform opacity-0 scale-95"
                                        >
                                            <Menu.Items className="absolute left-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                            <div className="py-1">
                                                <Menu.Item>
                                                {({ active }) => (
                                                    <button
                                                    onClick={()=>{setAssistAction("Summarize Conversation")}}
                                                    className={classNames(
                                                        active ? 'bg-gray-100 text-gray-900' : 'text-[var(--brand-secondary)]',
                                                        'block px-4 py-2 text-left text-sm w-full'
                                                    )}
                                                    >
                                                    Summarize Conversation
                                                    </button>
                                                )}
                                                </Menu.Item>
                                                <Menu.Item>
                                                {({ active }) => (
                                                    <button
                                                    onClick={()=>{setAssistAction("Make more friendly")}}
                                                    className={classNames(
                                                        active ? 'bg-gray-100 text-gray-900' : 'text-[var(--brand-secondary)]',
                                                        'block px-4 py-2 text-left text-sm w-full'
                                                    )}
                                                    >
                                                    Make more friendly
                                                    </button>
                                                )}
                                                </Menu.Item>
                                                <Menu.Item>
                                                {({ active }) => (
                                                    <button
                                                    onClick={()=>{setAssistAction("Make more formal")}}
                                                    className={classNames(
                                                        active ? 'bg-gray-100 text-gray-900' : 'text-[var(--brand-secondary)]',
                                                        'block px-4 py-2 text-left text-sm w-full'
                                                    )}
                                                    >
                                                    Make more formal
                                                    </button>
                                                )}
                                                </Menu.Item>
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <button
                                                        onClick={()=>{setAssistAction("Rephrase")}}
                                                        className={classNames(
                                                        active ? 'bg-gray-100 text-gray-900' : 'text-[var(--brand-secondary)]',
                                                        'block px-4 py-2 text-left text-sm w-full'
                                                        )}
                                                    >
                                                        Rephrase
                                                    </button>
                                                    )}
                                                </Menu.Item>
                                            </div>
                                            </Menu.Items>
                                        </Transition>
                                    </Menu>
                                </div>
                                <div className="mt-2">
                                    <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">
                                        AI generated response
                                    </label>
                                    <div>
                                        <div className="rounded-md bg-yellow-50 p-2">
                                            <div className="flex">
                                                <div className="ml-3">
                                                    <div className="mt-2 text-sm text-yellow-700">
                                                        <p>
                                                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid pariatur, ipsum similique veniam quo
                                                            totam eius aperiam dolorum.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                        
                                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                                        onClick={() => {
                                            let labArr = [...labelData]
                                            let obj = {
                                                label: labelName,
                                                desc: labelDescription,
                                                color: labelColor
                                            }
                                            labArr.push(obj);
                                            setLabelData(labArr);
                                            setLabelName("");
                                            setLabelDescription("");
                                            setLabelColor("");
                                            setOpen(false)
                                        }}
                                    >
                                        Send
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={() => setAssistPop(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
            
            {/* add lead popup */}
            
            <Transition.Root show={openLeadPopup} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpenLeadPopup}>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
                            <div>
                                <p className="flex text-lg leading-6 font-medium border-b pb-2 border-gray-200 mb-2">Add Information</p>                                           
                                <div className="flex gap-4">
                                    <div className="mt-2 w-1/2">
                                        <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                            Name
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                name="name"
                                                id="name"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                                placeholder="Name"
                                                value={fname}
                                                onChange={(e) => {
                                                    var regex = /[^a-zA-Z0-9\s]/g;
                                                    if (!regex.test(e.target.value)) {
                                                    setFname(e.target.value);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-2 w-1/2">
                                        <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">
                                            Email <span className="text-[red]">*</span>
                                        </label>
                                        <div>
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                                placeholder="Email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex gap-4">
                                    <div className="mt-2 w-1/2">
                                        <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                            Phone number
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                name="number"
                                                id="number"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                                placeholder="Phone Number"
                                                value={phone}
                                                onChange={(e) => {
                                                    const integerRegex = /^\d+$/; // This regex matches one or more digits
                                                    if ((integerRegex.test(e.target.value) || e.target.value === "") && e.target.value.length < 11) {
                                                    setPhone(e.target.value)
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div> 
                                    <div className="mt-2 w-1/2">
                                        <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                            City
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                name="city"
                                                id="city"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                                placeholder="City"
                                                value={city}
                                                onChange={(e) => setCity(e.target.value)}
                                            />
                                        </div>
                                    </div>  
                                </div>
                                <div className="flex gap-4">
                                    <div className="mt-2 w-1/2">
                                        <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                            Designation
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                name="designation"
                                                id="designation"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                                placeholder="Designation"
                                                value={designation}
                                                onChange={(e) =>
                                                    setDesignation(e.target.value)
                                                }
                                            />
                                        </div>
                                    </div> 
                                    <div className="mt-2 w-1/2">
                                        <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                            Company Name
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                name="company"
                                                id="company"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                                placeholder="Company Name"
                                                value={company}
                                                onChange={(e) => setCompany(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex pr-4">                                       
                                    <div className="mt-2 w-1/2">
                                        <label htmlFor="label" className="block text-sm font-medium leading-6 text-gray-900">
                                            Company Website
                                        </label>
                                        <div>
                                            <input
                                                type="text"
                                                name="website"
                                                id="website"
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                                placeholder="Company Website"
                                                value={companyWebsite}
                                                onChange={(e) =>
                                                    setCompanyWebsite(e.target.value)
                                                }
                                            />
                                        </div>
                                    </div>         
                                </div>   
                                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                                        onClick={(e) => {
                                            submitHandler(e);
                                        }}
                                    >
                                        Create
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={() => setOpenLeadPopup(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
            
            {/* add filter popup */}
            
            <Transition.Root show={filterPopup} as={Fragment}>
                <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setFilterPopup}>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                            <div>
                                <p className="flex text-lg leading-6 font-medium">Filter conversations</p>    
                                <p className="flex border-b pb-2 border-gray-200 mb-2 text-xs">Add your filters below and hit 'Apply filters' to cut through the chat clutter.</p>
                                <div className="flex justify-between">                                
                                    <div className="flex h-12 w-1/3 items-center">
                                        <select
                                            id="initial_filter"
                                            name="initial_filter"
                                            className="block w-full rounded-md border-0 py-2 font-normal pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-xs sm:leading-6"
                                            value={initialFilter}
                                            onChange={(e) => { 
                                                setInitialFilter(e.target.value)
                                            }}        
                                        >   
                                            <option value="status">Status</option>
                                            <option value="assignee">Assignee name</option>
                                            <option value="team">Team name</option>
                                            <option value="label">Labels</option>
                                            {/* <option>Created at</option>
                                            <option>Last activity</option> */}
                                        </select>
                                    </div>
                                    
                                    <div className="flex h-12 w-1/4 items-center">
                                        <select
                                            id="middle_filter"
                                            name="middle_filter"
                                            className="block w-full rounded-md border-0 py-2 font-normal pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-xs sm:leading-6"
                                            value={filterOperator}
                                                onChange={(e) => {
                                                setFilterOperator(e.target.value)
                                            }} 
                                        >
                                            <option value="equal">Equal to</option>
                                            <option value="not_equal">Not Equal to</option>
                                        </select>
                                    </div>
                                            
                                    <div className="flex h-12 w-1/3 items-center">
                                        {initialFilter === "status" && <select
                                            id="end_filter_one"
                                            name="end_filter_one"
                                            className="block w-full capitalize rounded-md border-0 py-2 font-normal pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-xs sm:leading-6"
                                            value={filterNewValue}
                                            onChange={(e) => {
                                                setFilterNewValue(e.target.value);
                                                const selectedId = e.target.value;
                                                const selectedObject = statusFilter.find(option => option.name == selectedId);
                                                setFilterValue(selectedObject);
                                            }}
                                        >   <option value="">Select an option</option>
                                            {statusFilter.map((stat, s_ind) => {
                                                return (
                                                    <option key={stat.id} value={stat.name}>{stat.name}</option>
                                                );
                                            })}
                                        </select>}
                                                
                                        {initialFilter === "assignee" && <select
                                            id="end_filter_two"
                                            name="end_filter_two"
                                            className="block w-full capitalize rounded-md border-0 py-2 font-normal pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-xs sm:leading-6"
                                            value={filterNewValue}
                                            onChange={(e) => {
                                                setFilterNewValue(e.target.value);
                                                const selectedId = e.target.value;
                                                const selectedObject = assign_list.find(option => option.user_id == selectedId);
                                                setFilterValue(selectedObject);
                                            }}
                                        >   <option value="">Select an option</option>
                                            {assignAgentList.map((agent) => {
                                                return (
                                                    <option  key={agent.user_id} value={agent.user_id} className="capitalize">{ agent.first_name +" "+ agent.last_name }</option>
                                                );
                                            })}
                                        </select>}

                                        {initialFilter === "team" && <select
                                            id="end_filter_three"
                                            name="end_filter_three"
                                            className="block w-full capitalize rounded-md border-0 py-2 font-normal pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-xs sm:leading-6"
                                            value={filterNewValue}
                                            onChange={(e) => {
                                                setFilterNewValue(e.target.value);
                                                const selectedId = e.target.value;
                                                const selectedObject = team_list.find(option => option.team_id == selectedId);
                                                setFilterValue(selectedObject);
                                            }}
                                        >   <option value="">Select an option</option>
                                            {team_list.map((team) => {
                                                return (
                                                    <option key={team.team_id} value={team.team_id} className="capitalize">{ team?.team_name }</option>
                                                );
                                            })}
                                        </select>}
                                                
                                        {initialFilter === "label" && <select
                                            id="end_filter_four"
                                            name="end_filter_four"
                                            className="block w-full capitalize rounded-md border-0 py-2 font-normal pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[var(--brand-primary)] sm:text-xs sm:leading-6"
                                            value={filterNewValue}
                                            onChange={(e) => {
                                                setFilterNewValue(e.target.value);    
                                                const selectedId = e.target.value;
                                                const selectedObject = labelData.find(option => option.tag_id == selectedId);
                                                setFilterValue(selectedObject);
                                                
                                            }}
                                        >   <option value="">Select an option</option>
                                            {labelData.map((label) => {
                                                return (
                                                    <option key={label.tag_id} value={label.tag_id} className="capitalize">{ label?.tag_name }</option>
                                                );
                                            })}
                                        </select>}                                                
                                    </div>
                                </div>                                            
                                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                    <button
                                        type="button"
                                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                                        onClick={(e) => {
                                            handleQueryChange(newId1, newId2, sortingValue);
                                        }}
                                    >
                                        Apply Filter
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={() => setFilterPopup(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
            
            {/* searching */}
            
            <Transition.Root show={showSearchPopup} as={Fragment}>
                <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setShowSearchPopup}>
                    <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                    >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                        <Dialog.Panel className={`relative transform overflow-hidden border p-4 max-sm:w-full rounded-lg text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl bg-[#f2f2f2] border-gray-300`}>
                            <div className={""}>
                            {/* {viewModal !== false && <h3 className="not-italic text-center mb-3 font-bold text-2xl leading-[29px] text-[#00000094]">{ "Preview" }</h3>} */}
                            <div className="d-flex flex-column popup-emoji">
                                <div className="relative w-full">
                                    <DebounceInput
                                            value={searchValue}
                                            className="block w-full rounded-md border-0 py-1.5 pr-8 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                            placeholder="Search by email, phone number, messages for better results."
                                            minLength={3}
                                            debounceTimeout={500}
                                            onChange={handleSearch}
                                        />
                                        <div className="absolute z-[9] cursor-pointer right-2 top-1/4">
                                            {searchValue && searchValue !== "" ? (
                                                <X className="h-4 w-4 text-gray-400 pointer" onClick={handleRemoveSearch} />
                                            ) : (
                                                <MagnifyingGlassIcon className="h-4 w-4 text-gray-400 cursor-pointer" onClick={handleSearch} />
                                            )}
                                        </div>
                                </div>
                                <div className="w-full">
                                    <div className='w-full max-sm:w-full'>
                                        <div className="">
                                            <div>
                                            <nav className="flex w-full sm:space-x-2 border-b border-gray-200" aria-label="Tabs">
                                                {searchTabs.map((tab, t_ind) => (
                                                <div
                                                    key={tab.name}
                                                    // href={tab.href}
                                                    onClick={() => {
                                                        setSearchTabName(tab.name);
                                                        setSearchListData([]);
                                                        if (searchValue !== "") {
                                                            dispatch(fetchSearchList(authToken, searchValue, tab.name, null, null, onSuccessSearch, onFailureSearch));
                                                        }
                                                    }}
                                                    className={classNames(
                                                        tab.name === searchTabName 
                                                        ? 'border-[var(--brand-primary)] text-gray-900'
                                                        : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-[var(--brand-secondary)]',
                                                    'not-italic flex gap-2 items-center leading-5 whitespace-nowrap max-sm:w-1/2 border-b-2 py-2 text-center px-1 text-sm font-medium cursor-pointer'
                                                    )}
                                                    aria-current={tab.current ? 'page' : undefined}
                                                >
                                                    <span>{tab.name}</span> 
                                                    {searchValue !=="" && <span className="inline-flex items-center rounded-md bg-gray-100 px-1 py-0 text-[10px] font-medium text-gray-600 ring-1 ring-inset ring-gray-800/10">
                                                    {getCount(searchCount, t_ind)}
                                                    </span>}
                                                </div>
                                                ))}
                                            </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>            
                                <div className="h-[70vh] overflow-y-auto listing p-2 mt-2 bg-white border border-gray-300 rounded-md">
                                    {/* {searchListData?.length !== 0 && <p className="text-sm font-semibold text-gray-600 mt-2">{searchTabName}</p>}                                             */}
                                    {searchTabName === "Contacts" && searchListData?.length > 0 && <>
                                        {searchListData?.map((search, s_ind) => {
                                            return (
                                                <div
                                                    key={s_ind}
                                                    className={`w-full cursor-pointer mb-3 hover:bg-gray-100 bg-transparent divide-gray-200`}
                                                    onClick={() => {
                                                        handleParamChange(search?.inbox_id, search.conversation_id);
                                                    }}
                                                >
                                                    <div className="relative w-full items-center justify-between p-2">
                                                        <div className="flex items-center gap-4">
                                                            <div>
                                                                <div
                                                                    className="bg-[var(--brand-primary)] relative text-center text-white p-[0.4rem] w-9 rounded-full"
                                                                >
                                                                    {getChars(search.name || "Unknown")}
                                                                </div>
                                                            </div>
                                                            <div className="w-[70%]">
                                                                <div className="flex space-x-4">
                                                                    <div className="flex-1 truncate">
                                                                        <div className="flex items-center space-x-3">
                                                                            <h3 className="truncate text-sm font-medium text-gray-900">
                                                                                {search.name || "Unknown"}
                                                                            </h3>
                                                                        </div>
                                                                        {(search.email !=="" || search.phone !== "") && <p className="flex items-center gap-2 mt-1 truncate text-xs text-gray-500">
                                                                            {search.email !== "" ? search.email:""}
                                                                            {(search.email !=="" && search.phone !== "") && <CircleFill className="text-gray-400 h-1.5 w-1.5" />}
                                                                            {search.phone !== "" ? search.phone : ""}
                                                                        </p>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </>}
                                                
                                    {/* {searchTabName === "Conversations" &&
                                        <div
                                            className={`w-full cursor-pointer mb-3 hover:bg-white bg-transparent divide-gray-200`}
                                            onClick={() => {
                                                // handleParamChange(item?.inbox_id, item.conversation_id);
                                            }}
                                        >
                                            <div className="relative w-full items-center justify-between p-2">
                                                <div className="flex items-center gap-4">
                                                    <div>
                                                        <div
                                                            className="border border-gray-300 relative text-center text-white p-[0.4rem] w-9 rounded-full"
                                                            // title={
                                                            //     userData?.first_name + " " + userData?.last_name
                                                            // }
                                                        >
                                                            <BsWechat className="h-5 w-5 text-gray-400"/>
                                                        </div>
                                                    </div>
                                                    <div className="w-[70%]">
                                                        <div className="flex space-x-4">
                                                            <div className="flex-1 truncate">
                                                                <div className="flex items-center space-x-3">
                                                                    <h3 className="truncate text-sm font-medium text-gray-900">
                                                                        {"Bot wrote:"}
                                                                    </h3>
                                                                </div>
                                                                <p className="mt-1 truncate text-xs text-gray-500">
                                                                    {"Conversation was marked resolved by Harish Kumar"}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    } */}
                                                
                                    {searchTabName === "Messages" && searchListData?.length > 0 &&
                                        <>
                                            {searchListData?.map((search, s_ind)=>{
                                                return (
                                                    <div
                                                        key={s_ind}
                                                        className={`w-full cursor-pointer mb-3 hover:bg-gray-100 rounded-lg bg-transparent divide-gray-200`}
                                                        onClick={() => {
                                                            handleParamChange(search?.inbox_id, search.conversation_id);
                                                        }}
                                                    >
                                                        <div className="relative w-full items-center justify-between p-2">
                                                            <div className="flex items-center gap-4">
                                                                <div>
                                                                    <div
                                                                        className="border border-gray-300 relative text-center text-white p-[0.4rem] w-9 rounded-full"
                                                                        // title={
                                                                        //     userData?.first_name + " " + userData?.last_name
                                                                        // }
                                                                    >
                                                                        <BsWechat className="h-5 w-5 text-gray-400"/>
                                                                    </div>
                                                                </div>
                                                                <div className="w-[70%]">
                                                                    <div className="flex space-x-4">
                                                                        <div className="flex-1 truncate">
                                                                            <div className="flex items-center space-x-3">
                                                                                <h3 className="truncate capitalize text-sm font-medium text-gray-900">
                                                                                    {(search.source === "assign" || search.source === "chatbot") ? "Bot" : search?.sender_name || search?.source || "Channel"} {"wrote:"}
                                                                                </h3>
                                                                            </div>
                                                                            <p className="mt-1 truncate text-xs text-gray-500">
                                                                                {search.message}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </>
                                    } 

                                    {searchListData?.length === 0 && 
                                        <div className="text-[rgba(33,33,33,0.3)] flex items-center justify-center h-[60vh] text-[17px] font-[bolder] text-center font-add">
                                            <div className="block">
                                                <span className="flex justify-center items-center text-[40px]">
                                                    <Inbox />
                                                </span>
                                                No Data
                                            </div>
                                        </div>
                                    }                                                
                                </div>     
                            </div>
                        </div>
                        </Dialog.Panel>
                        </Transition.Child>
                    </div>
                    </div>
                </Dialog>
            </Transition.Root>
            
        </>
    );    
}
